<template>
    <v-navigation-drawer v-model="navDrawer" :permanent="persistent" :rail="!full" :mobile-breakpoint="breakpoint">

        <v-img class="mx-auto mt-3 mb-3 w-50" :src="logoSrc" />
        <v-divider />

        <v-list density="compact" color="secondary" nav>
            <template v-for="item in filteredNav" :key="item.name">
                <v-divider v-if="item.divider" />

                <!-- Items without children -->
                <v-list-item v-if="!item.children" :id="item.elemId || null" class="text-left" :title="item.meta.title"
                    :prepend-icon="item.meta.icon" :to="{ name: item.name }" />

                <!-- Items with children -->
                <v-list-group v-else :value="item.title">
                    <template v-slot:activator="{ props }">
                        <v-list-item class="text-left" v-bind="props" :title="item.meta.title"
                            :prepend-icon="item.meta.icon" />
                    </template>

                    <!-- Sub-items 1 level deep-->
                    <v-list-item v-for="(subItem, s) in item.children" :key="s" :id="subItem.elemId || null"
                        class="text-left" :title="subItem.meta.title" :prepend-icon="subItem.meta.icon"
                        :to="{ name: subItem.name }" />
                </v-list-group>
            </template>
        </v-list>

        <template v-slot:append>

            <v-list density="compact" color="secondary" nav>

                <SupportMenu />

                <v-list-item class="text-left" title="Service Health" prepend-icon="mdi-wrench"
                    append-icon="mdi-open-in-new" href="https://status.screenflow.co.uk" target="_blank" />

            </v-list>

            <ProfileMenu />

            <!-- <div class="text-center text-caption">
                <span>{{ copyright }}</span>
            </div> -->
        </template>
    </v-navigation-drawer>
</template>

<script>
import constants from '@/config/constants';
import SupportMenu from '@/components/menus/SupportMenu';
import ProfileMenu from '@/components/menus/ProfileMenu';

export default {
    name: 'NavSidebar',
    data() {
        return {
            copyright: constants.app.meta.copyright,
        }
    },
    props: {
        modelValue: Boolean,
        nav: Object,
        full: Boolean,
        persistent: Boolean,
        breakpoint: String,
    },
    components: {
        SupportMenu,
        ProfileMenu,
    },
    computed: {
        navDrawer: {
            get() { return this.modelValue },
            set(value) { this.$emit('update:modelValue', value) },
        },
        filteredNav() {

            //Get the user roles from Auth0
            const userRoles = this.$auth0.user.value[constants.auth.namespaces.roles];

            //Check that the roles have loaded in and are not undefined
            if (userRoles) {

                const filterItems = (items) => {

                    return Object.entries(items).reduce((acc, [key, item]) => {

                        if (item.meta && item.meta.rbac && item.meta.rbac.some(role => userRoles.includes(role))) {

                            acc[key] = item;  //If the item itself matches, include it and its children
                        }

                        if (item.children && typeof item.children === 'object') {

                            const filteredChildren = filterItems(item.children);  //Recursively filter children

                            if (Object.keys(filteredChildren).length > 0) {

                                //Only include this item if it has valid children after filtering
                                acc[key] = { ...item, children: filteredChildren };
                            }
                        }

                        return acc;
                    }, {});
                };

                return filterItems(this.nav);
            } else {
                return {};
            }
        },
        logoSrc() {
            if (this.$vuetify.theme.current.dark) {
                return constants.app.logo.dark;
            } else {
                return constants.app.logo.light;
            }
        },
    },
}
</script>